import React, { useRef, useState } from "react";
//@ts-ignore
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import { selectConfigData } from "../../redux/config/configSlice";
import { useAppSelector } from "../../redux/hooks";
import Loading from "../LoadingPage/Loading";

interface TelerikReportingProps {
  params: { [key: string]: any };
  reportName: string;
  reportEndPoint: string;
}

const $ = (window as any).$;

const TelerikReporting: React.FC<TelerikReportingProps> = ({
  params,
  reportName,
  reportEndPoint,
}) => {
  const [isLoading, setLoading] = useState<boolean>(true);
  const configData = useAppSelector(selectConfigData);
  const token = localStorage.getItem("jwtToken") ?? null;
  const reportViewerRef = useRef<any>(null);

  const reportSource = {
    report: reportName, // name of the report file that you want to render
    parameters: {
      ReportUrl: `${configData?.appApiBaseUrl}/${reportEndPoint}`,
      AuthToken: `Bearer ${token}`,
      ...params,
    },
  };

  const hideNonPdfExports = () => {
    document
      .querySelectorAll<HTMLElement>("[data-command-parameter]")
      .forEach((item) => {
        const format = item.getAttribute("data-command-parameter");
        if (format && format !== "PDF") {
          item.style.display = "none";
        }
      });
  };

  // Hide pagination buttons based on view mode
  const handlePaginationHide = () => {
    const currViewMode = reportViewerRef.current?.getViewMode();
    if ($) {
      const isInteractive = currViewMode === "INTERACTIVE";
      const selectors = [
        "[data-command='telerik_ReportViewer_goToNextPage']",
        "[data-command='telerik_ReportViewer_goToPrevPage']",
        "[data-command='telerik_ReportViewer_goToLastPage']",
        "[data-command='telerik_ReportViewer_goToFirstPage']",
      ].join(", ");

      $(selectors).parent().add(".trv-report-pager").toggle(!isInteractive);
    }
  };

  const handlePageReady = () => {
    setLoading(false);
    hideNonPdfExports();
    handlePaginationHide();

    // Disable switching between scale modes on double click/double tap
    if ($) {
      const kendoTouch = $(".trv-pages-area").data("kendoTouch");
      if (kendoTouch) {
        kendoTouch.unbind("doubletap");
      }
    }

    const largeMenu = document.querySelector(".trv-menu-large");
    largeMenu?.addEventListener("mouseover", hideNonPdfExports);

    const sideMenu = document.querySelector(".trv-side-menu");
    sideMenu?.addEventListener("click", hideNonPdfExports);
  };

  const handleError = () => {
    setLoading(false);
  };

  return (
    <div style={{ position: "relative", height: "100%", width: "100%" }}>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 10,
            background: "var(--background, #fff)",
          }}
        >
          <Loading />
        </div>
      )}
      <TelerikReportViewer
        ref={reportViewerRef}
        reportSource={reportSource}
        viewerContainerStyle={{ height: "100%", width: "100%" }}
        serviceUrl={`${configData?.appApiBaseUrl}/reports`}
        scaleMode="FIT_PAGE_WIDTH"
        scale="1.0"
        enableAccessibility={false}
        pageReady={handlePageReady}
        error={handleError}
      />
    </div>
  );
};

export default TelerikReporting;